<template>
  <div class="error-page">
    <div class="error">
      <svg class="error-img" v-html="svgData.systemErrorSvg"/>
      <div class="error-message">
        <div class="four-and-four">404</div>
        <div class="no-page">出现异常了！</div>
        <div class="abnormal">对不起，您要访问的页面出现了异常，请联系管理员。</div>
        <div class="abnormal">出错原因：</div>
        <div class="error-person">
          <zwx-scrollbar-y style="height:100%">
            <span ref="errorMess" class="error-mess"
                  :style="showTotal ? 'overflow: hidden; -webkit-line-clamp: 2;' : 'display: block;'">
              {{ mess }}
            </span>
          </zwx-scrollbar-y>
        </div>
        <div class="open-cut-out" @click.stop.prevent="onOpen" v-if="messShow">
          <el-button class="zwx-button zwx-button-text-20" type="text">{{ showTotal ? '展开' : '收起' }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import svgData from './js/svg-data'

export default {
  name: 'ErrorPage',
  data() {
    return {
      svgData: svgData,
      showTotal: true,
      messShow: true,
      mess: this.$route.params.mess,
    }
  },
  mounted() {
    this.messShow = this.$refs.errorMess.scrollHeight > this.$refs.errorMess.offsetHeight
  },
  methods: {
    onOpen() {
      this.showTotal = !this.showTotal
    },
  },
}
</script>

<style lang="less" scoped>
.error-page {
  .error {
    width: 1056px;
    height: 100%;
    background: #fff;
    margin: 0 auto;
    display: flex;

    .error-img {
      margin-top: 153px;
      margin-left: 80px;
      margin-bottom: 153px;
      width: 450px;
      height: 406px;
    }

    .error-message {
      font-size: 14px;
      margin-top: 151px;
      margin-left: 31px;
      color: #191919;
      font-weight: 400;
    }

    .error-message > .four-and-four {
      font-size: 60px;
      height: 60px;
      line-height: 60px;
      font-family: DINCond, DINCond-Bold;
      font-weight: 700;
      color: #bcc1cc;
      letter-spacing: 9px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

    .error-message > .no-page {
      margin-top: 12px;
      font-size: 18px;
      height: 18px;
      line-height: 18px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

    .error-message .abnormal {
      margin-top: 12px;
      height: 12px;
      line-height: 12px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

    .error-message > .error-person {
      margin-top: 7px;
      word-break: break-all;
      color: #aaaaaa;
      width: 396px;
    }

    .error-message > .open-cut-out {
      float: right;
      width: 38px;
    }

    .error-message > .error-person .error-mess {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      text-align: justify;
      width: 385px;
      max-height: 327px;
    }
  }
}
</style>
<style lang="less"></style>
